import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Users } from "lucide-react";

const COLOR_HEX = {
    Bleu: "#3b82f6", Blanc: "#fafafa", Rouge: "#dc2626", Noir: "#18181b",
    Vert: "#16a34a", Jaune: "#eab308", Orange: "#ea580c", Violet: "#9333ea",
    Rose: "#ec4899", Gris: "#6b7280",
};

export { COLOR_HEX };

export default function ClubHeader({ club }) {
    return (
        <header>
            <div className="flex items-center gap-2 mb-4 text-xs uppercase tracking-widest text-zinc-500">
                <Link to="/clubs" className="hover:text-orange-500">Clubs</Link>
                <span>/</span>
                <span className="text-zinc-300">{club.name}</span>
            </div>
            <div className="flex flex-wrap items-end justify-between gap-6">
                <div>
                    <div className="flex items-center gap-2 mb-2">
                        <span className="chip border-orange-500/40 text-orange-500">{club.sport}</span>
                        <span className="chip border-zinc-700 text-zinc-300">{club.level}</span>
                        <span className="chip border-zinc-700 text-zinc-300">{club.num_teams} équipes</span>
                    </div>
                    <h1 className="font-display text-6xl md:text-8xl uppercase leading-[0.85] tracking-tighter">
                        {club.name}
                    </h1>
                    <div className="mt-4 flex flex-wrap gap-4 text-sm text-zinc-400">
                        <span className="inline-flex items-center gap-1.5">
                            <MapPin size={14} className="text-orange-500" />
                            {club.city} · {club.department}
                        </span>
                        <span className="inline-flex items-center gap-1.5">
                            <Users size={14} className="text-orange-500" />
                            {club.num_players} joueurs · {club.num_teams} équipes
                        </span>
                    </div>
                    {(club.teams_by_category || []).length > 0 && (
                        <div className="mt-3 flex flex-wrap gap-2">
                            {club.teams_by_category.map((t) => (
                                <span key={t.age_category} className="chip border-zinc-700 text-zinc-300">
                                    {t.age_category}: {t.num_teams}×{t.players_per_team}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
                <div className="flex flex-wrap gap-2">
                    {club.colors?.map((c) => (
                        <span
                            key={c}
                            className="chip border-zinc-700 text-zinc-300 inline-flex items-center gap-1.5"
                        >
                            <span
                                className="w-2.5 h-2.5 rounded-full inline-block border border-zinc-600"
                                style={{ background: COLOR_HEX[c] || "#a1a1aa" }}
                            />
                            {c}
                        </span>
                    ))}
                </div>
            </div>
            {club.description && (
                <p className="mt-6 max-w-3xl text-zinc-300">{club.description}</p>
            )}
            {club.needs && (
                <div className="mt-4 border-l-2 border-orange-500 pl-4 max-w-3xl">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-orange-500 font-bold mb-1">
                        Besoins exprimés
                    </div>
                    <p className="text-zinc-200">{club.needs}</p>
                </div>
            )}
        </header>
    );
}
